module.exports.config = {
  "declarative": true,
  "render-module": {
    "name": "PieceEventsRenderModule",
    "path": "front/piece-events-render.module"
  },
  "definition": {
    "type": "pieceEvents",
    "name": "PieceEventsDefinition",
    "group": "Components",
    "availablePlatforms": ["web", "apps"],
    "description": "Events",
    "isNew": true,
    "fields": [
      {
        "name": "eventId",
        "label": "Id del evento",
        "type": "plainText",
        "mandatory": false
      },
      {
        "name": "embedCode",
        "label": "Contenido embebido",
        "type": "plainText",
        "mandatory": false
      },
      {
        "label": "Opciones de visualización",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          {
            "name": "showEventText",
            "label": "Mostrar texto de eventos",
            "type": "boolean",
            "mandatory": true,
            "defaultValue": true
          },
          {
            "name": "showPlace",
            "label": "Mostrar lugar del evento",
            "type": "boolean",
            "mandatory": true,
            "defaultValue": true
          },
          {
            "name": "showDate",
            "label": "Mostrar fecha del evento",
            "type": "boolean",
            "mandatory": true,
            "defaultValue": true
          },
          {
            "name": "showTime",
            "label": "Mostrar hora del evento",
            "type": "boolean",
            "mandatory": true,
            "defaultValue": true
          },
          {
            "name": "showDuration",
            "label": "Mostrar duración del evento",
            "type": "boolean",
            "mandatory": true,
            "defaultValue": true
          },
          {
            "name": "showAvailablePlaces",
            "label": "Mostrar plazas disponibles",
            "type": "boolean",
            "mandatory": true,
            "defaultValue": true
          },
          {
            "name": "showEmbedCode",
            "label": "Forzar componente embebido",
            "type": "boolean",
            "mandatory": true,
            "defaultValue": false
          }
        ]
      },
      {
        "label": "Textos a mostrar",
        "type": "groupCollapsable",
        "flattenFields": true,
        "fields": [
          {
            "name": "nextEventText",
            "label": "Texto de próximo evento",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-proximo-evento}}"
          },
          {
            "name": "howToGetThereText",
            "label": "Texto de cómo llegar",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-como-llegar}}"
          },
          {
            "name": "durationText",
            "label": "Texto de duración",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-duracion}}"
          },
          {
            "name": "durationDaysText",
            "label": "Texto de días",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-derechos-dias}}"
          },
          {
            "name": "durationDayText",
            "label": "Texto de día",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-derechos-dia}}"
          },
          {
            "name": "durationHoursText",
            "label": "Texto de horas",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-derechos-horas}}"
          },
          {
            "name": "durationHourText",
            "label": "Texto de hora",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-derechos-hora}}"
          },
          {
            "name": "durationMinutesText",
            "label": "Texto de minutos",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-derechos-minutos}}"
          },
          {
            "name": "durationMinuteText",
            "label": "Texto de minuto",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-derechos-minuto}}"
          },
          {
            "name": "languageText",
            "label": "Texto de idioma",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-idioma}}"
          },
          {
            "name": "bookYourSpotText",
            "label": "Texto de reserva tu plaza",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-reserva-tu-plaza}}"
          },
          {
            "name": "nSpotsLeftText",
            "label": "Texto de quedan N plazas",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-quedan-N-plazas}}"
          },
          {
            "name": "soldOutText",
            "label": "Texto de plazas agotadas",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-plazas-agotadas}}"
          },
          {
            "name": "signInToBookYourSpotText",
            "label": "Texto de inicia sesión para reservar tu plaza",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-inicia-sesion-para-reservar-tu-plaza}}"
          },
          {
            "name": "cantAttendText",
            "label": "Texto de no podrás asistir",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-no-podras-asistir}}"
          },
          {
            "name": "cancelYourBookingText",
            "label": "Texto de cancela tu reserva",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-cancela-tu-reserva}}"
          },
          {
            "name": "bookingConfirmedText",
            "label": "Texto de reserva confirmada",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-reserva-confirmada}}"
          },
          {
            "name": "bookingConfirmationText",
            "label": "Texto de Email de confirmación",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-booking-confirmation-text}}"
          },
          {
            "name": "youAreOnWaitlistText",
            "label": "Texto de estas en la lista",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-estas-lista}}"
          },
          {
            "name": "comingSoonText",
            "label": "Texto de próximamente",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-coming-soon}}"
          },
          {
            "name": "signInToJoinWaitlistText",
            "label": "Texto de inicia sesión para apuntarte a la lista",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-inicia-sesion-para-apuntarte-a-la-lista}}"
          },
          {
            "name": "joinWaitlistText",
            "label": "Texto de apuntarse a la lista de espera",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-apuntarse-a-la-lista-de-espera}}"
          },
          {
            "name": "nameText",
            "label": "Texto de nombre",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-nombre}}"
          },
          {
            "name": "surnameText",
            "label": "Texto de apellidos",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-apellidos}}"
          },
          {
            "name": "emailText",
            "label": "Texto de email",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-email}}"
          },
          {
            "name": "prefixText",
            "label": "Texto de prefijo",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-prefijo}}"
          },
          {
            "name": "phoneText",
            "label": "Texto de teléfono",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-telefono}}"
          },
          {
            "name": "receiveNewsText",
            "label": "Texto de recibir novedades",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-recibir-novedades}}"
          },
          {
            "name": "termsConditionsText",
            "label": "Texto de términos y condiciones",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-terms-conditions}}"
          },
          {
            "name": "imageRightsText",
            "label": "Texto de derechos de imagen",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-derechos-imagen}}"
          },
          {
            "name": "newsletterText",
            "label": "Texto de newsletter",
            "type": "plainText",
            "mandatory": false,
            "defaultValue": "{{lang.landing_gestionReservas-newsletter}}"
          },
        ]
      }
    ]
  }
};

